module.exports = __webpack_public_path__ + "media/legends-never-die-ft-against-the-current-worlds-2017-league-of-legends.fb2bbab8.mp3";